import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ButtonComponent } from '@pc/button';
import { ResponsiveAbstractCardComponent } from '@pc/responsive-abstract-card';
import { BusinessUnit, ComponentSizes, PcButtonIcon } from '@pc/common';
import { ButtonDateType, DepartureReturnButtonState } from '../button-state.enum';
import { DepartureReturnDetailType } from '../departure-return-detail-type';

@Component({
  selector: 'pc-departure-return-detail',
  standalone: true,
  imports: [CommonModule, ResponsiveAbstractCardComponent, ButtonComponent],
  templateUrl: './departure-return-detail.component.html',
  styleUrl: './departure-return-detail.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class DepartureReturnDetailComponent {
  @Input({ required: true }) public editButtonText!: string;
  @Input({ required: true }) public editButtonDescription!: string;
  @Input({ required: true }) public departureAltText!: string;
  @Input({ required: true }) public returnAltText!: string;
  @Input() public details: DepartureReturnDetailType | undefined = undefined;
  @Input() public dateType: ButtonDateType = ButtonDateType.Departure;
  @Input() public size: ComponentSizes = 'xsmall';
  @Input() public showButtonImageAirplane = true;
  @Input() public businessUnit = BusinessUnit.IL;
  @Input() public isLTR = false;
  @Output() editDates = new EventEmitter<DepartureReturnButtonState>();

  public readonly PcButtonIcon = PcButtonIcon;
  public readonly ButtonState = DepartureReturnButtonState;
  public readonly ButtonDateType = ButtonDateType;
  public readonly BusinessUnit = BusinessUnit;

  public editDetails(): void {
    if (this.dateType === ButtonDateType.Departure) {
      this.editDates.emit(DepartureReturnButtonState.Departure);
    } else {
      this.editDates.emit(DepartureReturnButtonState.Return);
    }
  }
}
